import { useQuery, useMutation } from 'react-apollo';
import { useCallback } from 'react';

import getAccountCardPreviewFileQuery from '../../../../../../services/cards/graphql/queries/getAccountCardPreviewFile';
import getAccountCardPreviewDownloadFileQuery from '../../../../../../services/cards/graphql/queries/getAccountCardPreviewDownloadFile';
import { AccountCardsPhotoDownloadCreate } from '../../../../../../graphql/mutations/photo-downloads';

const useCollageDesignerSuccess = ({
  accountCardId,
  prepareDownload = false,
  pollInterval = 2000,
}) => {
  const { data: { accountCard } = {}, stopPolling } = useQuery(
    getAccountCardPreviewFileQuery,
    {
      variables: {
        id: accountCardId,
      },
      pollInterval,
      skip: !accountCardId,
    },
  );

  const { data: { accountCard: accountCardWithDownload } = {} } = useQuery(
    getAccountCardPreviewDownloadFileQuery,
    {
      variables: {
        id: accountCardId,
      },
      skip: !accountCardId || !prepareDownload,
    },
  );

  const [accountCardsPhotoDownloadCreate] = useMutation(
    AccountCardsPhotoDownloadCreate,
  );

  const onAccountCardsPhotoDownloadCreate = useCallback(
    async emailAddress => {
      if (!accountCardId) return null;

      const result = await accountCardsPhotoDownloadCreate({
        variables: {
          input: {
            name: 'Hi-res Collage',
            email_address: emailAddress,
            account_card_ids: [accountCardId],
          },
        },
      });

      return result;
    },
    [accountCardId, accountCardsPhotoDownloadCreate],
  );

  return {
    previewUrl: accountCard?.front_preview_file_url,
    previewDownloadUrl:
      accountCardWithDownload?.front_preview_file_download_url,
    stopPolling,
    onAccountCardsPhotoDownloadCreate,
  };
};

export default useCollageDesignerSuccess;
